<template>
  <div id="file-add-or-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie  v-if="loading == 'updateScreenLoading' && form == null" key="create-loading"  />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.files.fileAddUpdate.file") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.files.fileAddUpdate.fileMsg") }}</span>
                    </div>
                    <i v-if="logoPercent > 0" class="el-icon-loading"></i>
                    <i class="el-icon-info" v-else></i>
                  </el-tooltip>
                </div>
                <el-upload :class="$inputError('image', validationErrors)" :onProgress="logoProgress" class="upload-demo" :before-upload="logoBefore" drag :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=document&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" :show-file-list="false" :on-success="logoSuccess">
                  <div v-if="form.image == null">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      <template v-if="$i18n.locale == 'tr'">
                        Dosyayı buraya sürükleyin veya
                        <br />
                        <em>yüklemek için tıklayın</em>
                        <p class="text-muted">
                          İzin verilen uzantılar: .doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx, .gif, .txt, .jpg, .png
                        </p>
                      </template>

                      <template v-else>
                        Drag your file here
                        <b />
                        or <em>click to upload</em>
                        <p class="text-muted">
                          Allowed extensions: .doc, .docx, .pdf, .xls, .xlsx, .ppt, .pptx, .gif, .txt, .jpg, .png
                        </p>
                      </template>
                    </div>
                  </div>

                  <div v-if="form.image != null">
                    <img style="width: 40px" :src="'/static/icons/' + getExtension(form.image) + '.svg'" alt />
                    <div class="el-upload__text">
                      {{ form.image.split("/")[form.image.split("/").length - 1] }}
                    </div>
                  </div>
                </el-upload>
                <span class="error">{{ $errorMessage("image", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.files.fileAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.files.fileAddUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.files.fileAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.files.fileAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.files.fileAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.files.fileAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableCustomTags ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.enableCustomTags ? 'fa-tags' : 'fa-tags'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.files.fileAddUpdate.useTags") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.files.fileAddUpdate.useTagsMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableCustomTags"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableCustomTags">
                        <CustomTag :value="form.customTags" :key="form.id" v-model="form.customTags"></CustomTag>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.files.fileAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("contentManagement.files.fileAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabbled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.files.fileAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
export default {
  components: { ItemInfo },
  name: "FileAddUpdate",
  props: ["id", "categoryId"],
  data() {
    return {
      settingsDock: false,
      form: null,
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      loading: false,
      timeout: null,
    };
  },
  methods: {
    getExtension(url) {
      if (url == null) return "";
      return url.split(".")[url.split(".").length - 1];
    },
    deleteItem() {
      this.$emit("deleteMe", this.form);
      this.$emit("closeDialog");
    },
    async save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("documentFileAddUpdate", { ...this.form, categoryID: this.categoryId });
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
          await this.$store.dispatch("getDocumentCategoryList");
        }
        this.loading = false;
      }, 500);
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoBefore(file) {
      var size = file.size / 1024 ** 2;
      if (size > 30) {
        this.$message.error("Maximum 30mb boyutlu dosya yükleyebilirsiniz");
      }
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    },
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);

    if (this.id != undefined && this.id != null) {
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getDocumentFile", this.id);
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
        } else {
          this.$emit("closeMe");
        }
        this.loading = false;
      }, 500);
    } else {
      this.timeout = setTimeout(() => {
        this.form = {
          id: null,
          image: null,
          title: null,
          categoryID: null,
          orderNO: 99,
          isActive: true,
          enableCustomTags: false,
          customTags: [],
        };
        this.loading = false;
      }, 500);
    }
  },
};
</script>

<style lang="less">
.el-upload {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  width: 100%;
}

.registerform-input-container {
  .el-upload {
    width: 100% !important;
  }
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FileAddUpdate.vue